module.exports = __webpack_public_path__ + "media/offers/offer-pion-color-ba11cb69.png";